var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 13.6667C3.31816 13.6667 0.333496 10.682 0.333496 7.00004C0.333496 3.31804 3.31816 0.333374 7.00016 0.333374C10.6822 0.333374 13.6668 3.31804 13.6668 7.00004C13.6668 10.682 10.6822 13.6667 7.00016 13.6667ZM7.00016 12.3334C8.41465 12.3334 9.7712 11.7715 10.7714 10.7713C11.7716 9.77108 12.3335 8.41453 12.3335 7.00004C12.3335 5.58555 11.7716 4.229 10.7714 3.2288C9.7712 2.22861 8.41465 1.66671 7.00016 1.66671C5.58567 1.66671 4.22912 2.22861 3.22893 3.2288C2.22873 4.229 1.66683 5.58555 1.66683 7.00004C1.66683 8.41453 2.22873 9.77108 3.22893 10.7713C4.22912 11.7715 5.58567 12.3334 7.00016 12.3334ZM6.3335 9.00004H7.66683V10.3334H6.3335V9.00004ZM6.3335 3.66671H7.66683V7.66671H6.3335V3.66671Z",
    fill: "#EE5050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissed);
export default __webpack_public_path__ + "static/media/missed.9b6d3a7699bda6e9038e7b881cdf1c54.svg";
export { ForwardRef as ReactComponent };